import cn from "../../../utils/cn";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from "../Button/Button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MoreOrLessButton = _ref => {
  let {
    children,
    moreText = 'See more',
    lessText = 'See less',
    onClick = null,
    omitDefaultStyles = false,
    className = ''
  } = _ref;
  const [showMore, setShowMore] = useState(false);
  const onButtonClick = event => {
    event.preventDefault();
    setShowMore(!showMore);
    if (onClick) {
      onClick();
    }
  };
  const childrenWithFuncs = React.Children.map(children, child => child && /*#__PURE__*/React.cloneElement(child, {
    showMore,
    showLess: !showMore
  }));
  const buttonClass = cn({
    'pl-4 mx-auto text-center flex items-center hover:text-deep-blue focus:text-deep-blue': !omitDefaultStyles,
    [className]: className
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [childrenWithFuncs, /*#__PURE__*/_jsx(Button, {
      id: "more-or-less-toggle-btn",
      className: buttonClass,
      link: true,
      onClick: onButtonClick,
      label: "".concat(showMore ? lessText : moreText),
      icon: {
        name: 'ChevronArrow',
        color: 'hover:deep-blue',
        position: 'right',
        direction: "".concat(showMore ? 'up' : 'down')
      },
      "aria-expanded": showMore,
      tabIndex: "0",
      "aria-controls": "more-or-less-content",
      role: "button"
    })]
  });
};
MoreOrLessButton.propTypes = {
  /** Passed children components */
  children: PropTypes.node,
  /** Copy for the condensed mode */
  moreText: PropTypes.string,
  /** Copy for the expanded mode */
  lessText: PropTypes.string,
  /** Function to run on click */
  onClick: PropTypes.func,
  /** Should it omit default styles? */
  omitDefaultStyles: PropTypes.bool
};
export default MoreOrLessButton;
//# sourceMappingURL=MoreOrLessButton.js.map